import Vue from 'vue';
import Vuex from 'vuex';
import { vuexOidcCreateStoreModule } from 'vuex-oidc';

Vue.use(Vuex);

// eslint-disable-next-line no-console
console.log(`creating store in mode: ${process.env.NODE_ENV}`);

// determine hostname by NODE_ENV
const hostName = process.env.NODE_ENV === 'production'
  ? 'https://landscape.vigilantapps.com'
  : 'http://localhost:8080';

export default new Vuex.Store({
  modules: {
    oidcStore: vuexOidcCreateStoreModule({
      authority: 'https://login.vigilantapps.com',
      client_id: 'landscape-reporting',
      response_type: 'id_token token',
      scope: 'openid profile vipro-identity',
      // post log-on redirect
      redirect_uri: `${hostName}/signin-oidc`,
      // silent renewal
      automaticSilentRenew: true,
      silent_redirect_uri: `${hostName}/silent-refresh-oidc.html`,
      accessTokenExpiringNotificationTime: 45
    }),
  },
});
